import { modelState } from '@/utils/modelState';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace AlwaysCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "Always",
        name: "Always",
        isCondition: isAlwaysCondition,
        create: createAlwaysCondition,
        hydrate: () => { },
        serialize: serializeAlwaysCondition,
        deserialize: deserializeAlwaysCondition,
        renderComponent: () => null
    };

    export const AlwaysCondition = Symbol("AlwaysCondition");
    export interface AlwaysCondition extends QueryBuilder.ConditionNodeChild {
        [AlwaysCondition]: boolean;
    }

    export function isAlwaysCondition(condition?: QueryBuilder.ConditionNodeChild): condition is AlwaysCondition {
        if (!condition) {
            return false;
        }

        return (condition as AlwaysCondition)[AlwaysCondition] === true;
    }

    export function createAlwaysCondition(skipHydration: boolean = false): AlwaysCondition {

        const condition: AlwaysCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [AlwaysCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            dispose: () => { }
        };

        return condition;
    }

    function serializeAlwaysCondition(condition: AlwaysCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const alwaysDto: AlwaysConditionDto = {
            NodeId: condition.id
        };

        return {
            Type: "Always",
            Value: alwaysDto
        };
    }

    interface AlwaysConditionDto extends QueryBuilder.NodeDto {
        //
    }

    function deserializeAlwaysCondition(always: AlwaysConditionDto): AlwaysCondition {
        const condition = createAlwaysCondition(true);
        return condition;
    }
}